import axios from 'axios'
import cookie from 'vue-cookie'
//const token = cookie.get('authToken')

var inErrorFunction = false
export default () => {
  const objAx = axios.create({
    baseURL: process.env.VUE_APP_API,
    headers: {
      'Authorization': 'Bearer ' + cookie.get('mgc-authToken')
    }
  })
  objAx.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      console.log(error)
      if (!inErrorFunction) {
        inErrorFunction = true
        if (401 == error.response.status) {
          //TO_DO mettre une string
          document.getElementById("app").innerHTML += formatMessagePopUpInfo("Session expirée !", "Vous avez été déconnecté par le serveur, Veuillez vous reconnecter", "Reconnexion", "window.location.href='./login'")//TODO: String -> fr.json
          cookie.delete("mgc-authToken");
          cookie.delete("mgc-u-id");
        } else if (403 == error.response.status) {
          document.getElementById("app").innerHTML += formatMessagePopUpInfo("Oops !", "Vous n'avez pas la permission pour effectuer cette demande", "Annuler", "location.reload();")//TODO: String -> fr.json
        } else {
          return Promise.reject(error);
        }
      }
    }
  )

  function formatMessagePopUpInfo(txtTitle, txtBody, txtBtnAction, redirection) {
    return "<div id='#infoPopup' class='modal-mask'  style='text-align: center;'>"
      + "<section class='modal reduced'>"
      + "<div class='content'>"
      + "<div>"
      + "<h1>" + txtTitle + "</h1>"
      + "<div class='spacer-10'></div>"
      + "<p class='pStrong' style='text-align: center;'>" + txtBody + "</p>"
      + "<div class='spacer-10'></div>"
      + "<div class='spacer-10'></div>"
      + "<button onclick=\"" + redirection + "\">" + txtBtnAction + "</button>"
      + "<div class='spacer-10'></div>"
      + "</div>"
      + "</div>"
      + "</section>"
      + "</div>";
  }
  return objAx
}